export default __webpack_public_path__ + "static/media/waterMark.564eb223.svg";